var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 8.1875C15.625 7.6875 15.5625 7.3125 15.5 6.90625H8.125V9.5625H12.5C12.3438 10.7188 11.1875 12.9062 8.125 12.9062C5.46875 12.9062 3.3125 10.7188 3.3125 8C3.3125 3.65625 8.4375 1.65625 11.1875 4.3125L13.3125 2.28125C11.9688 1.03125 10.1875 0.25 8.125 0.25C3.8125 0.25 0.375 3.71875 0.375 8C0.375 12.3125 3.8125 15.75 8.125 15.75C12.5938 15.75 15.625 12.625 15.625 8.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ff0a17126bc8644216d0dcc7c5fa7576.svg";
export { ForwardRef as ReactComponent };